import React from 'react';
const NullView = () => <div>This View is not yet implemented...</div>;
export default NullView;
